import { MINCOL } from "../../../constants/const";
import DropdownFilter from "../SD_einsehen/DropdownFilter";

export const kreisHeader = [
    {accessor: 'id',
    Header: 'ID'},
    {accessor: 'id_land',
    Header: 'ID des zugehörigen Landes'},
    {accessor: 'kreis',
    Header: 'Name des Kreises',
    width: '11em'},
    {accessor: 'nummer',
    Header: 'Kreisnummer',
    width: MINCOL},
    {accessor: 'land',
    Header: 'zugehörig zu',
    Filter: DropdownFilter,
    width: '9em'},
];


export const kreisFormular = [
    {accessor: 'id_land',
    type: 'dropdown',
    label: 'zugehörig zu'},
    {accessor: 'kreis',
    type: 'input',
    label: 'Name des Kreises'},
    {accessor: 'nummer',
    type: 'input',
    label: 'Kreisnummer'},

]